// @flow

const complexStrategy = ({options}: FacetWithConfig): boolean => {
    const validOption = option => (
        option?.name && (option.options || []).reduce((acc, option) => acc && validOption(option), true)
    )

    return options.length > 0 && !options.find(option => !validOption(option));
};

export default complexStrategy;
